import { Button, Stack, Typography } from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";

interface SectionHeaderProps {
  title: string;
  action?: string;
  onAction?: () => void;
}

export default function SectionHeader({
  title,
  action,
  onAction,
}: SectionHeaderProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 2 }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>
        {title}
      </Typography>
      {action && (
        <Button
          onClick={onAction}
          startIcon={<AddRounded sx={{ fontSize: 14 }} />}
          sx={{
            border: "1px solid #c59a70",
            borderRadius: "20px",
            px: 2,
            py: 0.5,
            textTransform: "none",
            fontSize: "12px",
            color: "#c59a70",
            fontWeight: 500,
            "&:hover": { bgcolor: "#f8fafc" },
          }}
        >
          {action}
        </Button>
      )}
    </Stack>
  );
}
